import { render } from "./StoreTargetEdit.vue?vue&type=template&id=40da93b7&scoped=true"
import script from "./StoreTargetEdit.vue?vue&type=script&lang=js"
export * from "./StoreTargetEdit.vue?vue&type=script&lang=js"

import "./StoreTargetEdit.vue?vue&type=style&index=0&id=40da93b7&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40da93b7"]])

export default __exports__